import React, { useCallback } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useModalContext } from '@bcraft-frontend-lib/core'
import { BonusPromotionStatus, PROMOTIONS_MODAL_PATHS, usePromotionActivation } from '@bcraft-frontend-lib/promotions'
import block from 'bem-cn'

import { ROUTE_URLS } from 'router/routes'

import { getRouteParamsByStrings } from 'shared/utils/getRouteParamsByStrings'

import { selectLocaleDict } from 'features/locale/selectors'

import { ModalWrapper } from 'components/ModalWrapper'
import Button from 'components/UIKit/Button/Button'

import './ConfirmActivateBonus.scss'

const b = block('confirm-activate-bonus')

interface IConfirmActivateProps {
  path: string
}

interface ParamsMatch {
  id: string
}

export const ConfirmActivateBonus: React.FC<IConfirmActivateProps> = ({ path }) => {
  const history = useHistory()
  const { closeModal } = useModalContext()
  const locale = useSelector(selectLocaleDict, shallowEqual).bonuses

  const params = getRouteParamsByStrings<ParamsMatch>(PROMOTIONS_MODAL_PATHS.ACTIVATE_PROMOTION, path)
  const { activate } = usePromotionActivation(params?.id ?? '')

  const handleClose = useCallback(() => {
    closeModal(path)()
  }, [closeModal, path])

  const onConfirmActivateHandler = useCallback(() => {
    activate(() => {
      handleClose()
      history.push(ROUTE_URLS.PROFILE_PROMOTIONS_STATUS(BonusPromotionStatus.active))
    })
  }, [activate, handleClose, history])

  return (
    <ModalWrapper title={locale.confirmActivateBonus} className={b()} onClose={handleClose}>
      <div className={b('text')}>{locale.changeActiveBonusText}</div>
      <div className={b('button-wrapper')}>
        <div className={b('button')}>
          <Button text={locale.cancel} onClick={handleClose} />
        </div>
        <div className={b('button')}>
          <Button text={locale.activate} onClick={onConfirmActivateHandler} />
        </div>
      </div>
    </ModalWrapper>
  )
}
